<script setup lang="ts">
defineProps<{
  path: string
  type: string
  target?: string
}>()
</script>

<template>
  <div>
    <router-link
      v-if="type === 'internal'"
      :to="path"
    >
      <slot />
    </router-link>
    <a
      v-else-if="type === 'external'"
      :href="path"
      :target="target"
    >
      <slot />
    </a>
    <slot v-else />
  </div>
</template>
